

const WhyChooseUsSection = () => {
  const features = [
    {
      icon: 'ri-bank-line',
      title: 'Financial & Risk Insight',
      description: 'Thirty years working with business owners, financials, and risk gives us clear insight into valuations and deal structures.'
    },
    {
      icon: 'ri-team-line',
      title: 'People-First Approach',
      description: 'We keep your employees, customers, and community relationships front and center before, during, and after the sale.'
    },
    {
      icon: 'ri-settings-line',
      title: 'Flexible Deal Structures',
      description: 'Every business is unique. We craft acquisition terms that work for your specific situation and timeline.'
    }
  ];

  return (
    <section className="py-20 bg-soft-gray">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-playfair text-4xl font-bold text-navy mb-6">
              Why Choose Legacy Business Acquisitions
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              We're not just buyers. We're stewards of the businesses and communities we serve. Our approach combines decades of deal and risk expertise with genuine care for what you’ve built.
            </p>
            
            <div className="space-y-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#C9A227] rounded-lg flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-navy mb-2">{feature.title}</h3>
                    <p className="text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://static.readdy.ai/image/2a3205e7e8ef8b3d476f9ddb9e8c5218/de3a7cd5671f9e0f9610c00c47e0d15a.png"
              alt="Professional business meeting"
              className="rounded-lg shadow-lg w-full h-96 object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/20 to-transparent rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;

